/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import React from 'react';
import ReactDOM from 'react-dom';
import {withRouter} from "react-router";
import queryString from 'query-string';

import ReactSuperSelect from 'react-super-select';
import uuid from 'node-uuid';
import {Nav, NavItem, InputGroup, Form, FormGroup, FormControl, ControlLabel, Glyphicon, Label, Button, Panel, Grid, Row, Col, Image, Well} from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import ReactSpinner from 'react-spinjs';
import UserStore from '../../stores/UserStore';
import APIActions from '../../actions/apiActions';
import AppConstants from '../../constants/AppConstants';
import UIHelpers from '../../library/UIHelpers';

import ProductStore from '../../stores/ProductStore';
import DealerStore from '../../stores/DealerStore';
import JobStore from '../../stores/JobStore';
import JobStatusGridList from './jobStatusGridList';
import ModalConfirmView from '../modalConfirmView';
import JobHistorySelector from './jobHistorySelector';

let imgsrc = "http://savaria.azurewebsites.net/images/noimage.png" ;


class JobDetailEditView extends React.Component {
    constructor(props) {
        console.log("[JobDetailEditView] - initialisation");

        super(props);

        var jid = queryString.parse(props.location.search).id;
        var pid = queryString.parse(props.location.search).pid;

        this.cancel = this.cancel.bind(this);
        this.confirm = this.confirm.bind(this);
        this.delete = this.delete.bind(this);
        this.deleteCancel = this.deleteCancel.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.editPhoto = this.editPhoto.bind(this);

        this.selectHandler = this.selectHandler.bind(this);
        this.onChangeData = this.onChangeData.bind(this);
        this.reloadProducts = this.reloadProducts.bind(this);
        this.selectDealerHandler = this.selectDealerHandler.bind(this);

        this._onProductChange = this._onProductChange.bind(this) ;
        this._onDealerChange = this._onDealerChange.bind(this);
        this._onJobChange = this._onJobChange.bind(this);
        this.fixSelectedProduct = this.fixSelectedProduct.bind(this);
        this.fixSelectedDealer = this.fixSelectedDealer.bind(this);
        this.setJobPhoto = this.setJobPhoto.bind(this);

        var job = null ;
        var inserting = false ;
        if (jid === "new") {
            inserting = true ;
            job = {
                jobId : uuid.v4() ,
                name : undefined ,
                mac : undefined ,
                notes : undefined ,
                client : undefined,
                jobnum : undefined ,
                archivePeriod : 30,
                productId : pid,
                dealerId : null
            };
        }

        this.state = {
            inserting : inserting,
            dirty : false,
            deleting : false,
            jobId : jid,
            job : job,
            jobname : null,
            jobnum : null,
            macaddress : null,
            notes : null,
            clientname : null,
            products : [],
            productsView : [],
            selectedProduct : null,
            dealers : [],
            dealersView : [],
            selectedDealer : null,
            savingJob : false,
            targetProduct : pid,
            selectedProductView : undefined,
            selectedDealerView : undefined,
            targetDealerId : null,
            archivePeriod : 30
        }
    }

    componentDidMount() {
        console.log("[JobDetailEditView] - componentDidMount");
        ProductStore.addChangeListener(this._onProductChange) ;
        DealerStore.addChangeListener(this._onDealerChange) ;
        JobStore.addChangeListener(this._onJobChange) ;
        this.reloadProducts();
        APIActions.allDealers() ;

        if (this.state.jobId !== "new") {
            APIActions.loadJob(this.state.jobId);
        }
    }

    componentWillUnmount() {
        console.log("[JobDetailEditView] - componentWillUnmount");
        ProductStore.removeChangeListener(this._onProductChange);
        DealerStore.removeChangeListener(this._onDealerChange);
        JobStore.removeChangeListener(this._onJobChange);
    }

    _onProductChange() {
        var s = this.state ;
        s.products = ProductStore.products() ;
        s.productsView = s.products.map(item => ({id: item.productId, name: item.name, size: "Small", product: item}));
        this.setState(s);
        this.fixSelectedProduct();
    }

    fixSelectedProduct() {
        var s = this.state ;

        if (s.targetProduct) {
            var pd = s.products.filter((p) => p.productId === s.targetProduct);
            if (pd && pd.length === 1) {
                console.log("EDIT JOB: selected product=", pd[0]);
                s.selectedProduct = pd[0] ;
                var sv = s.productsView.filter((pv) => pv.id === s.targetProduct) ;
                if (sv && sv.length === 1) {
                    s.selectedProductView = sv[0] ;
                }
            }
        }
        else {
            s.selectedProductView = undefined ;
        }

        this.setState(s);
    }

    fixSelectedDealer() {
        var s = this.state ;
        console.log("FIX DEALER: ", s.targetDealerId);

        if (s.targetDealerId) {
            var sd = s.dealers.filter((d) => d.dealerId === s.targetDealerId) ;
            if (sd && sd.length === 1) {
                console.log("EDIT JOB: selected dealer=", sd[0]);
                s.selectedDealer = sd[0];
                var sv = s.dealersView.filter((dv) => dv.id === s.targetDealerId) ;
                if (sv && sv.length === 1) {
                    console.log("SELECTED DEALER VIEW: ", sv[0])
                    s.selectedDealerView = sv[0] ;
                }
            }
        }
        else {
            s.selectedDealerView = undefined ;
        }

        this.setState(s);
    }

    _onDealerChange() {
        var s = this.state ;
        s.dealers = DealerStore.dealers() ;
        s.dealersView = s.dealers.map(item => ({id: item.dealerId, name: item.name, size: "Small", dealer: item}));
        this.setState(s);
        this.fixSelectedDealer();
    }

    setJobPhoto(photo) {
        console.log("[JOB] set photo to: ", photo);
        var s = this.state ;
        s.job.photo = photo ;
        s.dirty = true ;
        this.setState(s);
    }

    _onJobChange(payload) {
        console.log("JOB_CHANGE: payload=", payload);

        if (payload) {
            switch (payload.event) {
                case AppConstants.JOB_IMAGE_SAVE:
                    this.setJobPhoto(payload.photo);
                    break ;
                case AppConstants.JOB_IMAGE_SAVE_ERR:
                    this.setJobPhoto(null);
                    break ;
                case AppConstants.SAVE_JOB:
                    UIHelpers.showMessage("Job Details Saved");
                    var job = JobStore.currentJob() ;
                    if (this.state.inserting) {
                        this.setState({dirty: false, savingJob : false, inserting : false, jobId : job.jobId});
                        this.props.history.replace("/jobs/job?id=" + job.jobId + "&pid=" + job.productId);
                    }
                    else if (this.state.savingJob) {
                        this.setState({dirty: false, savingJob : false, inserting : false});
                    }
                    break ;
                case AppConstants.SAVE_JOB_ERR:
                    UIHelpers.showMessage("A problem occurred saving the Job info - please retry or cancel");
                    break ;

                case AppConstants.DELETE_JOB :
                    UIHelpers.showMessage("Job Deleted");
                    this.props.history.replace("/jobs");
                    break ;

                case AppConstants.DELETE_JOB_ERR :
                    UIHelpers.showMessage("A problem occurred deleting the Job info - please retry or cancel");
                    break ;

                case AppConstants.LOAD_JOB:
                    var s = this.state ;
                    var job = JobStore.currentJob() ;
                    if (!job) {
                        return ;
                    }

                    s.job = job ;
                    s.jobId = job.jobId ;
                    s.jobname = job.displayName ;
                    s.macaddress = job.mac ;
                    s.notes = job.notes ;
                    s.clientname = job.client;
                    s.jobnum = job.jobnum ;
                    s.archivePeriod = job.archivePeriod || 30;
                    s.targetDealerId = job.dealerId ;
                    s.targetProduct = job.productId ;
                    this.setState(s);
                    this.fixSelectedProduct();
                    this.fixSelectedDealer() ;
                    break ;

                default:
                    return ;
            }
        }
    }

    reloadProducts() {
        APIActions.getAllProducts() ;
    }

    cancel() {
        var conf = true ;
        if (this.state.dirty) {
            conf = UIHelpers.confirmAction("You have made changes - are you sure you want to leave this page?");
        }

        if (conf) {
            JobStore.clear();
            this.props.history.push("/jobs");
        }
    }

    delete() {
        console.warn("[JOB] - deleting");
        var s = this.state ;
        s.deleting = true ;
        this.setState(s);
    }

    deleteCancel() {
        var s = this.state ;
        s.deleting = false ;
        this.setState(s);
    }

    deleteConfirm() {
        var s = this.state ;
        s.deleting = false ;
        this.setState(s);

        APIActions.deleteJob(this.state.jobId);
    }

    archiveRetentionDays() {
        return this.state.archivePeriod || 30 ;
    }

    confirm() {
        var s = this.state ;
        var job = this.state.job ;
        if (s.inserting) {
            // adding a new job
            console.log("[JOB-NEW]");
            job.notes = s.notes ;
            job.name = s.jobname === ""  || !s.jobname ? "" : s.jobname.toUpperCase() ;
            job.jobnum = s.jobnum ;
            job.displayName = s.jobname ;
            job.mac = s.macaddress;
            job.productId = s.selectedProduct.productId ;
            job.photo = s.selectedProduct.imageUrl ;
            job.state = {
            };
        }
        else {
            console.log("[JON-UPDATE - ", job);
            // editing an existing job
            job.notes = s.notes ;
            job.name = s.jobname === ""  || !s.jobname ? "" : s.jobname.toUpperCase() ;
            job.displayName = s.jobname ;
            job.mac = s.macaddress ;
            job.jobnum = s.jobnum ;
        }

        job.archivePeriod = this.archiveRetentionDays() ;
        job.client = s.clientname ;

        if (s.selectedDealer) {
            job.dealerId = s.selectedDealer.dealerId ;
        }
        else {
            delete job.dealerId  ;
        }

        if (job.notes === "") {
            delete job.notes  ;
        }

        if (job.client === "") {
            delete job.client  ;
        }

        if (job.mac === "") {
            delete job.mac ;
        }

        if (job.name === "") {
            delete job.name ;
            delete job.displayName  ;
        }

        if (job.jobnum === "") {
            delete job.jobnum  ;
        }

        s.savingJob = true ;
        this.setState(s);
        console.log("[JOB] = ", job);
        console.log("[JOB-State] = ", s);
        APIActions.saveJob(job);
    }


    selectHandler(product) {
        console.log("[PRODUCT SELECT] - " + JSON.stringify(product));
        var s = this.state ;
        s.selectedProduct = product ? product.product : null;
        s.dirty = true ;
        this.setState(s);
    }

    selectDealerHandler(dealer) {
        console.log("[DEALER SELECT] - " + JSON.stringify(dealer));
        var s = this.state ;
        s.selectedDealer = dealer.dealer ;
        s.dirty = true ;
        this.setState(s);
    }

    onChangeData(e) {
        e.preventDefault() ;
        var jid = ReactDOM.findDOMNode(this.refs.jobId).value;
        var jn = ReactDOM.findDOMNode(this.refs.jobname).value;
        var ma = ReactDOM.findDOMNode(this.refs.macaddress).value;
        var nt = ReactDOM.findDOMNode(this.refs.notes).value;
        var cn = ReactDOM.findDOMNode(this.refs.clientname).value;
        var jnum = ReactDOM.findDOMNode(this.refs.jobnum).value;

        var s = this.state ;
        s.jobId = jid ;
        s.jobname = jn ;
        s.macaddress = ma ;
        s.notes = nt ;
        s.clientname = cn ;
        s.dirty = true ;
        s.jobnum = jnum ;
        this.setState(s);
    }

    editPhoto(event) {
        console.log("SELECT IMAGE: ", event.target.files[0]);
        var s = this.state ;
        s.job.photo = null ;
        this.setState(s);
        APIActions.attachImageToJob(this.state.job.jobId, event.target.files[0]) ;
    }

    render() {
        var isAdmin = UserStore.isAdministrator();
        var isTech = UserStore.isTechSupport();
        var title = (this.state.jobId !== "new" || false) ? "Edit Job" : "Add Job";

        if (!this.state.job) {
            return (
                <Grid>
                <p>Please wait. Loading job detail.....</p>
                </Grid>
            );
        }

        if (this.state.job.photo) {
            imgsrc = this.state.job.photo + "#" + new Date().getTime();
        }

        let isDealer = UserStore.isDealer() ;
        let editableProduct = this.state.inserting;

        return (
            <div>
            <ModalConfirmView
                    visible={this.state.deleting}
                    title="Confirm Job Delete"
                    message="Are you sure you want to delete this Job?"
                    onCancel={this.deleteCancel}
                    onConfirm={this.deleteConfirm} />

            <Grid>
                <Row>
                   <Well className="jobHeader">
                       <h2>Job Detail : {this.state.jobname} - {this.state.jobnum}</h2>
                       <Button bsStyle="info" onClick={this.cancel}><Glyphicon glyph="arrow-left"/>{' '}Back to Jobs List</Button>{' '}{' '}
                       <Button bsStyle="success" onClick={this.confirm} disabled={!this.state.dirty}><Glyphicon glyph="save"/>{' '}Save Job</Button>{' '}{' '}
                       <Button bsStyle="danger" onClick={this.delete} ><Glyphicon glyph="trash"/>{' '}Delete Job</Button>
                   </Well>
               </Row>
                <Row><Col><br /></Col></Row>
                <Row>
                    <Col md={4}>
                        <Panel header="Detail">
                        <Form horizontal onSubmit={event => event.preventDefault()}>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} md={3}>Job Identifier</Col>
                                <Col md={7}>
                                    <FormControl type="text" readOnly ref="jobId" value={this.state.jobId}/>
                                </Col>
                            </FormGroup>

                            <FormGroup controlId="formHorizontalEmail" >
                                <Col componentClass={ControlLabel} md={3}>Product</Col>
                                <Col sm={7}>
                                    <ReactSuperSelect placeholder="Select Product"
                                            initialValue={this.state.selectedProductView}
                                            clearSearchOnSelection={false}
                                            dataSource={this.state.productsView}
                                            onChange={this.selectHandler}
                                            searchable={true}
                                            disabled={isDealer || !editableProduct}
                                            clearable={!isDealer && editableProduct}/>
                                </Col>
                            </FormGroup>

                            <FormGroup controlId="formHorizontalEmail" >
                                <Col componentClass={ControlLabel} md={3}>Dealer</Col>
                                <Col sm={7}>
                                    <ReactSuperSelect placeholder="Select Dealer"
                                            initialValue={this.state.selectedDealerView}
                                            clearSearchOnSelection={false}
                                            dataSource={this.state.dealersView}
                                            onChange={this.selectDealerHandler}
                                            searchable={true}
                                            disabled={isDealer}
                                            clearable={!isDealer} />
                                </Col>
                            </FormGroup>

                             <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} md={3}>Job Number</Col>
                                <Col sm={7}>
                                    {(isAdmin || isTech) && <FormControl onChange={this.onChangeData} type="text" ref="jobnum" value={this.state.jobnum}/>}
                                    {(!isAdmin && !isTech) && <FormControl readOnly onChange={this.onChangeData} type="text" ref="jobnum" value={this.state.jobnum}/>}
                                </Col>
                            </FormGroup>

                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} md={3}>Job Name</Col>
                                <Col sm={7}>
                                    <FormControl onChange={this.onChangeData} type="text" ref="jobname" value={this.state.jobname}/>
                                </Col>
                            </FormGroup>

                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} md={3}>Client</Col>
                                <Col sm={7}>
                                    <FormControl onChange={this.onChangeData} type="text" ref="clientname" value={this.state.clientname}/>
                                </Col>
                            </FormGroup>

                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} md={3}>MAC Address</Col>
                                <Col sm={7}>
                                    {(isAdmin || isTech)  && <FormControl onChange={this.onChangeData} type="text" ref="macaddress" value={this.state.macaddress}/>}
                                    {(!isAdmin && !isTech) && <FormControl readOnly onChange={this.onChangeData} type="text" ref="macaddress" value={this.state.macaddress}/>}
                                </Col>
                            </FormGroup>
                        </Form>
                        </Panel>
                    </Col>
                    <Col md={4}>
                        <Panel header="Photo">
                            <FormControl className="pull-right" bsStyle="success"  type="file" accept="image/png" disabled={this.state.inserting} onChange={this.editPhoto} /><br/>
                            <Image src={imgsrc} thumbnail />
                        </Panel>
                    </Col>
                    <Col md={4}>
                        <Panel header="Notes">
                            <FormControl componentClass="textarea" style={{height: '220px'}} width="100%"  ref="notes" value={this.state.notes}  onChange={this.onChangeData}/>
                        </Panel>

                        {isAdmin &&
                            <Panel header="Archive Period">
                                <Nav bsStyle="pills"  bsSize="xsmall" activeKey={this.state.archivePeriod} onSelect={(v) => this.setState({archivePeriod: v, dirty: true})}>
                                    <NavItem eventKey={30} >30 days</NavItem>
                                    <NavItem eventKey={60} >60 days</NavItem>
                                    <NavItem eventKey={90} >90 days</NavItem>
                                    <NavItem eventKey={180} >180 days</NavItem>
                                    <NavItem eventKey={365} >365 days</NavItem>
                                </Nav>
                            </Panel>
                        }

                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <JobStatusGridList job={this.state.job} editable={!this.state.inserting} />
                    </Col>
                </Row>
            </Grid>
            </div>
        );
    }
}

export default withRouter(JobDetailEditView);



// WEBPACK FOOTER //
// ./src/app/components/jobs/jobDetailEditView.js